import './CurrentWorkspaceSelectorOption.scss';
import { useTranslator } from '@Localization';
import classNames from 'classnames';
import { ReactElement } from 'react';
import { IWorkspace, WorkspaceRole } from '../../../../../../__legacy__/modules/workspaces/workspaces.store';
import { S_WorkspaceOwnerIcon } from '../../../../../../design/icons/S_WorkspaceOwnerIcon/S_WorkspaceOwnerIcon';

interface IProps {
  workspace: IWorkspace;
}

export const CurrentWorkspaceSelectorOption = ({ workspace }: IProps): ReactElement => {
  const { t } = useTranslator();

  const encrypted = workspace.encryption.encrypted;
  const locked = workspace.locked;
  const owned = workspace.role === WorkspaceRole.Owner;
  const label = workspace.name;
  const prefix = encrypted ? '🔒 ' : '';
  const suffix = locked ? t('workspaces.current.locked') : '';

  return (
    <div className={classNames('current-workspace-selector-option', { 'option-role-owner': owned, disabled: locked })}>
      <S_WorkspaceOwnerIcon
        isMine={owned}
        notOwnerTitle={workspace.ownerEmail}
      />
      {`${prefix} ${label} ${suffix}`}
    </div>
  );
};
